export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6653.8bdd8127.jpg";